/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["share-dialog .emails-container{display:flex;min-height:54px}share-dialog .emails-container chip-input{flex:1 1 auto}share-dialog .emails-container .mat-flat-button{height:54px;border:1px solid #e0e0e0;border-left:none}share-dialog .mat-tab-body{padding:15px 0}"];
export { styles as styles };
